import React from 'react';
import { Alert, Tooltip } from '@mui/material';

/**
 * Shown while staff preview the customer surface. The turn really runs as a PM (allowlist, MCP code
 * path, redaction), so this states that plainly, and the tooltip names the one thing it cannot copy.
 */
export function LivyPreviewBanner(_ref) {
  let companyLabel = _ref.companyLabel;
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: "Matches a PM account holder, who sees the whole company. A regular PM limited to assigned portfolios may see less."
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: "warning",
    variant: "outlined",
    role: "status",
    sx: {
      mx: '16px',
      mt: '10px',
      py: 0,
      borderRadius: '10px',
      '& .MuiAlert-message': {
        fontSize: 13
      }
    }
  }, companyLabel ? "Viewing as a property manager at ".concat(companyLabel, ". Same tools and data they get.") : 'Pick a company in the switcher to preview what its property managers see.'));
}